// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';

const styles = css`
  .esg-badge {
    &-wrapper {
      display: flex;
      padding-left: 10px;
      padding-right: 8px;
      column-gap: 16px;

      @media ${(props) => props.theme.mediaQuery.medium} {
        padding: 12px 0;
      }

      @media ${(props) => props.theme.mediaQuery.large} {
        padding: 12px 0 12px 5px;
      }
    }

    &-icon-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-icon {
      position: relative;
      min-height: 52px;
      min-width: 52px;
      height: 52px;
      width: 52px;
      @media ${(props) => props.theme.mediaQuery.large} {
        min-height: 60px;
        min-width: 60px;
        height: 60px;
        width: 60px;
      }
    }

    &-title {
      height: 18px;
      max-height: 18px;
      margin-bottom: 2px;
      overflow: hidden;
      font-weight: 700;
      letter-spacing: 0.5px;
      color: ${(props) => props.theme.colors.BLACK};

      @media ${(props) => props.theme.mediaQuery.medium} {
        font-size: 14px;
      }
    }

    &-description {
      font-weight: 400;
      max-height: 80px;
      overflow: hidden;
      letter-spacing: 0.5px;
      text-align: left;
      line-height: 16px;
      color: ${(props) => props.theme.colors.BLACK};

      @media ${(props) => props.theme.mediaQuery.medium} {
        font-size: 14px;
        line-height: 19px;
        max-height: 95px;
      }

      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        letter-spacing: normal;
      }
    }

    &-description a {
      text-decoration: underline;
      cursor: pointer;
      color: ${(props) => props.theme.colorPalette.blue[1300]};

      @media ${(props) => props.theme.mediaQuery.medium} {
        font-size: 14px;
      }
    }
  }
`;

const ESGBadgeContainer = Styled.div`
  display:flex;
  flex-direction: column;
  row-gap: 24px;
  ${styles}
`;

export default ESGBadgeContainer;
